module.exports = __webpack_public_path__ + "img/stock6.c4700853.png";